import { useEffect, useState } from 'react';

import { Box } from '@mui/material';

import Checkbox from '../../../form/Checkbox';
import Input from '../../../form/Input';
import CustomDialog from '../../../layout/CustomDialog';

const dadosIniciais = {
    descricao: '',
    ativo: true,
};

export default function SubGrupoDialog({ open, onClose, selected, loading = false, onConfirm }) {
    const [dados, setDados] = useState(dadosIniciais);
    const isEdicao = Boolean(selected);

    useEffect(() => {
        if (!open) return;

        setDados({
            descricao: selected?.descricao ?? '',
            ativo: selected?.ativo ?? true,
        });
    }, [open, selected]);

    const handleChange = (event) => {
        const { name, value, checked, type } = event.target;

        setDados((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleConfirm = () => {
        const descricao = dados.descricao.trim();
        if (!descricao) return;

        onConfirm({
            ...selected,
            ...dados,
            descricao,
        });
    };

    return (
        <CustomDialog
            open={Boolean(open)}
            title={`${isEdicao ? 'Editar' : 'Cadastrar'} Subgrupo`}
            content={
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                        minWidth: { xs: 'auto', sm: 360 },
                        pt: 1,
                    }}
                >
                    <Input
                        text="Descrição"
                        type="text"
                        name="descricao"
                        placeholder="Subgrupo"
                        inputWidth="100%"
                        title="Digite a descrição do subgrupo"
                        handleOnChange={handleChange}
                        value={dados.descricao}
                        required
                    />

                    <Checkbox
                        title="Ativa o subgrupo quando marcado"
                        text="Ativo"
                        name="ativo"
                        handleOnChange={handleChange}
                        value={dados.ativo}
                        checked={Boolean(dados.ativo)}
                    />
                </Box>
            }
            onClose={onClose}
            onConfirm={handleConfirm}
            disableConfirm={!dados.descricao.trim()}
            loading={loading}
            confirmLabel={isEdicao ? 'Atualizar' : 'Cadastrar'}
            confirmColor="success"
        />
    );
}
